import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { ControlFacet } from '../models/controls/ControlFacet';

export const itemsBreadcrumbControl = new ControlFacet<{
  itemsScopeItemKey: string;
  itemKey: string | undefined;
}, {
    createOpenItem: (nextItemKey: string) => () => void;
    rootItemKey?: string;
    getBreadcrumbItems: () => IBreadcrumbItem[];
  }>('itemsBreadcrumbControl');
